import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { colors } from '../../../../../themes/stena-recycling/colors';
import { animationTransition } from '../../../../helpers/styleHelpers';
import { spacing } from '../../../../../themes/stena-recycling/spacing';
import { typography } from '../../../../../themes/stena-recycling/typography';

export const TableRow = styled.tr<{ clickable?: boolean }>`
  border-bottom: 1px solid ${colors.monochrome.grey20};

  &:last-of-type {
    border-bottom: none;
  }

  ${({ clickable }) =>
    clickable &&
    css`
      cursor: pointer;
      transition: background-color ${animationTransition};

      &:hover {
        background-color: ${colors.background.grey};
      }
    `}
`;

export const TableCell = styled.td<{ verticalAlign: string }>`
  padding: ${spacing.xsmall};
  font-family: inherit;
  ${typography.body.large};
  vertical-align: ${({ verticalAlign }) => verticalAlign};
`;

export const TableCellExpanded = styled(TableCell)`
  padding: 0;
`;
